export class ArtifactoryCookies {

    constructor($cookies) {
        this.cookies = $cookies;
    }

    getCookie(cookieName) {
        return this.cookies[cookieName]
    }

}


// WEBPACK FOOTER //
// ./services/artifactory_cookies.js